

























import Vue from 'vue'
import { mapMutations } from 'vuex'
export default Vue.extend({
  data: () => {
    return {
      navigation: [
        {
          name: 'Статистика',
          icon: 'pie_chart',
          url: '/',
          admin: false,
        },
        {
          name: 'Парсинг',
          icon: 'http',
          url: '/spiders/',
          admin: false,
        },
        {
          name: 'Записи',
          icon: 'videocam',
          url: '/recordings/',
          admin: true,
        },
        {
          name: 'Пропуски',
          icon: 'report_problem',
          url: '/missing',
          admin: false,
        },
        {
          name: 'Публикации',
          icon: 'assignment',
          url: '/last',
          admin: true,
        },
        {
          name: 'Поиск',
          icon: 'search',
          url: '/search',
          admin: true,
        },
      ],
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated']
    },
    userNavigation() {
      if (this.isAdmin) {
        return this.navigation
      }

      return this.navigation.filter(x => x.admin === false)
    },
  },
  created() {
    if (this.isAuthenticated) {
      this.$store.dispatch('auth/FETCH_USER')
    }
  },
  methods: {
    logout() {
      this.$store.commit('auth/LOGOUT')
      this.$router.push({ name: 'Login' })
    },
    ...mapMutations({
      toggleSidebar: 'settings/TOGGLE_SIDEBAR',
    }),
  },
})
